// extracted by mini-css-extract-plugin
module.exports = {"align-left":"style_align-left__smRtb","align-center":"style_align-center__x59Tj","align-right":"style_align-right__aIUai"};